module.exports = __webpack_public_path__ + "img/20200514_144534.5be5629b.jpg";